<template>
  <div>
    <table class="table table-sm table-bordered">
      <thead class="thead-light">
        <tr>
          <th class="w-15">{{ "id" | translate }}</th>
          <th class="w-20">{{ "in" | translate }}</th>
          <th class="w-20">{{ "out" | translate }}</th>
          <th>{{ "ref" | translate }}</th>
          <th class="w-30">{{ "description" | translate }}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(trans, index) in transactions" :key="'trans' + index">
          <td>{{ trans.id }}</td>
          <td>
            <span v-if="trans.in"
              >{{ trans.in | number(2) }} {{ trans.currency | translate }}</span
            >
          </td>
          <td>
            <span v-if="trans.out"
              >{{ trans.out | number(2) }}
              {{ trans.currency | translate }}</span
            >
          </td>
          <td>{{ trans.ref }}</td>
          <td>
            {{ trans.dailyReportId }} / {{ trans.orderType | translate }} /
            {{ trans.orderIndex + 1 }}
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <th>{{ "total" | translate }}</th>
          <th>
            <div
              v-for="(currency, cuIndex) in currencyList(transactions)"
              :key="'in' + cuIndex"
            >
              {{ calIn(transactions, currency) | number(2) }}
              {{ currency | translate }}
            </div>
          </th>
          <th>
            <div
              v-for="(currency, cuIndex) in currencyList(transactions)"
              :key="'out' + cuIndex"
            >
              {{ calOut(transactions, currency) | number(2) }}
              {{ currency | translate }}
            </div>
          </th>
          <th colspan="2" class="text-right">
            <div
              v-for="(currency, cuIndex) in currencyList(transactions)"
              :key="'bal' + cuIndex"
            >
              {{ calBalance(transactions, currency) | number(2) }}
              {{ currency | translate }}
            </div>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  props: ["transactions"],

  methods: {
    calIn(transactions, currency) {
      return transactions.reduce((sum, trans) => {
        if (trans.currency === currency) {
          if (trans.in) {
            sum += trans.in;
          }
        }
        return sum;
      }, 0);
    },
    calOut(transactions, currency) {
      return transactions.reduce((sum, trans) => {
        if (trans.currency === currency) {
          if (trans.out) {
            sum += trans.out;
          }
        }
        return sum;
      }, 0);
    },
    calBalance(transactions, currency) {
      return transactions.reduce((sum, trans) => {
        if (trans.currency === currency) {
          if (trans.in) {
            sum += trans.in;
          }
          if (trans.out) {
            sum -= trans.out;
          }
        }
        return sum;
      }, 0);
    },
    currencyList(transactions) {
      return [...new Set(transactions.map(trn => trn.currency))];
    }
  }
};
</script>
